<table class="table-fixed w-full">
  <thead>
    <tr>
      <th class="text-left py-2 px-2 md:px-6 text-[0.8125rem]/[1.5rem] md:text-[0.9375rem] font-bold">
        {{ 'balance.paymentDate' | translate }}
      </th>
      <th class="text-left py-2 px-2 md:px-6 text-[0.8125rem]/[1.5rem] md:text-[0.9375rem] font-bold">
        {{ 'balance.period' | translate }}
      </th>
      <th class="text-left py-2 px-2 md:px-6 text-[0.8125rem]/[1.5rem] md:text-[0.9375rem] font-bold">
        {{ 'balance.amount' | translate }}
      </th>
      <th class="hidden md:table-cell text-left py-2 px-6 text-[0.9375rem]/[1.5rem] font-bold">
        {{ 'balance.status' | translate }}
      </th>
    </tr>
  </thead>
  <tbody>
    @for (row of paymentRows(); track row.payment.id) {
      @let payment = row.payment;
      <tr class="h-14">
        <td
          class="whitespace-nowrap text-[0.8125rem]/[1.5rem] md:text-[0.9375rem] px-2 md:px-6 py-2"
          [class.color-neutral-300]="payment.status === 'Pending'"
          [class.color-neutral-700]="payment.status !== 'Pending'"
        >
          {{ row.dateLabel }}
        </td>
        <td class="whitespace-nowrap text-[0.8125rem]/[1.5rem] md:text-[0.9375rem] px-2 md:px-6 py-2">
          @if (!row.hasDetails) {
            <span class="color-neutral-700">{{ row.periodLabel }}</span>
          } @else {
            <button
              type="button"
              class="underline color-secondary-500 cursor-pointer"
              (click)="goToPaymentDetails(payment)"
            >
              {{ row.periodLabel }}
            </button>
          }
        </td>
        <td class="text-[0.8125rem]/[1.5rem] md:text-[0.9375rem] color-neutral-700 px-2 md:px-6 py-2">
          <div class="flex flex-col items-start gap-1">
            <span>{{ row.amountLabel }}</span>
            @if (row.adjustmentLabel) {
              <span class="text-xs color-neutral-500" data-payment-adjustment>
                {{ 'balance.paymentAdjustment' | translate }}: {{ row.adjustmentLabel }}
              </span>
            }
            <app-tag class="md:hidden" [type]="row.tagType">
              {{ row.statusTranslationKey | translate }}
            </app-tag>
          </div>
        </td>
        <td class="text-[0.9375rem]/[1.5rem] hidden md:table-cell px-6 py-2">
          <app-tag class="inline-block" [type]="row.tagType">
            {{ row.statusTranslationKey | translate }}
          </app-tag>
        </td>
      </tr>
    }
  </tbody>
</table>

<div class="w-full text-center mt-4 text-[0.9375rem]/[1.5rem] color-neutral-400">
  {{ 'balance.paymentsAccumulateMonthly' | translate }}
</div>
